import { type ReactNode } from 'react';
import { cn } from '@/utils/cn';
import { dailyTier } from '@/utils/daily-achievement';
import type { EnrichedMember } from '../types';

const TD = 'px-md py-sm text-xs';

function TodayCell({ count, min }: { count: number; min: number }): ReactNode {
  const tier = dailyTier(count);
  return (
    <td className={TD}>
      <span className={cn('flex items-center gap-1', tier.color)}>
        {tier.icon}
        {count}/{min}
      </span>
    </td>
  );
}

function StreakCell({ streak }: { streak: number }): ReactNode {
  return (
    <td className={TD}>
      <span className="text-text-secondary">{streak}d</span>
    </td>
  );
}

function AccumCell({ eur }: { eur: number }): ReactNode {
  const formatted = '$' + eur.toFixed(2).replace('.', ',');
  return (
    <td className={TD}>
      <span className="text-text-secondary">{formatted}</span>
    </td>
  );
}

export function CollectorStats({ m }: { m: EnrichedMember }): ReactNode {
  const hasStats = m.today_count !== undefined;
  if (!hasStats) {
    return (
      <>
        <td className={TD}>—</td>
        <td className={TD}>—</td>
        <td className={TD}>—</td>
      </>
    );
  }
  return (
    <>
      <TodayCell count={m.today_count ?? 0} min={m.daily_minimum ?? 33} />
      <StreakCell streak={m.current_streak ?? 0} />
      <AccumCell eur={m.accumulated_eur ?? 0} />
    </>
  );
}
